module.exports = __webpack_public_path__ + "static/media/galerija_2023 (22).5147c89c.png";